import { ErrorHandler, Injectable, Injector, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { logger } from "../../../../../submodules/engine-common/logger";

/**
 * La funzione handleError viene richiamata quando un errore risale fino alla root dell'applicazione angular (errori non gestiti tramite try-catch).
 * Per attivare questo handler è necessario inserire il seguente provider in app.module.ts
 * { provide: ErrorHandler, useClass: GlobalErrorHandler }
 */
@Injectable()
export class GlobalErrorHandler implements ErrorHandler {

    constructor(private _injector: Injector) { }

    handleError(error) {
        if (error.message.includes('Cannot match any routes')) {
            if (error.message.includes('URL Segment: \'private')) //<- in caso di route che inizia con 'private' si manda alla home privata
                //Senza NGZone la navigazione sembra andare a buon fine ma si vede solo una pagina bianca
                this._injector.get(NgZone).run(() => this._injector.get(Router).navigate(["/private"]))
            else                                                  //<- altimenti si manda alla home pubblica
                //Senza NGZone la navigazione sembra andare a buon fine ma si vede solo una pagina bianca
                this._injector.get(NgZone).run(() => this._injector.get(Router).navigate(['/']));
        }
        else {
            logger.error(`${error.message}:${error.stack}`);
            throw error;
        }
    }
}